import { styled } from '@linaria/react';

const UserRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const UserBubble = styled.div`
  max-width: 75%;
  padding: 10px 16px;
  border-radius: 18px 18px 4px 18px;
  background: var(--sky-lighter);
  color: var(--ink-darkest);
  font-size: 15px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const AssistantRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const AvatarWrap = styled.div`
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--sky-lighter);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
`;

const AvatarImg = styled.img`
  width: 18px;
  height: 18px;
`;

const AssistantBubble = styled.div`
  max-width: 85%;
  padding: 4px 0;
  position: relative;
  min-width: 0;

  /*
   * When the turn is presenting clarifying-question cards, fill the full
   * max-width instead of shrink-wrapping. This keeps every question card a
   * consistent width — otherwise the bubble sizes to each question's own
   * content and the width jumps between questions and between tabs of a
   * multi-question card. Scoped to the flag, so plain text bubbles still
   * shrink-wrap as before.
   */
  &[data-has-questions='true'] {
    width: 100%;
    box-sizing: border-box;
  }

  &, & * {
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  p {
    margin: 0 0 8px;
    color: var(--ink-base);
    font-size: 15px;
    line-height: 1.6;
  }
  p:last-child { margin-bottom: 0; }

  h1, h2, h3, h4, h5, h6 {
    margin: 12px 0 6px;
    font-weight: 700;
    color: var(--ink-darkest);
  }
  h1 { font-size: 20px; }
  h2 { font-size: 18px; }
  h3 { font-size: 16px; }
  h4, h5, h6 { font-size: 15px; }
  h1 strong, h2 strong, h3 strong, h4 strong, h5 strong, h6 strong { color: inherit; }

  ul, ol {
    margin: 6px 0 6px 18px;
    padding-left: 0;
  }
  li {
    margin: 3px 0;
    color: var(--ink-base);
    font-size: 15px;
    line-height: 1.6;
  }

  table {
    border-collapse: collapse;
    margin: 8px 0;
    width: 100%;
    font-size: 14px;
  }
  th, td {
    border: 1px solid var(--sky-light);
    padding: 6px 10px;
    text-align: left;
    color: var(--ink-base);
  }
  th {
    background: var(--sky-lighter);
    font-weight: 600;
    color: var(--ink-dark);
  }

  strong { color: inherit; }

  code {
    font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
    font-size: 13.5px;
    background: var(--flora-code-bg);
    padding: 1px 4px;
    border-radius: 3px;
  }

  a {
    color: var(--flora-link-color);
    text-decoration-line: underline;
    text-decoration-color: color-mix(in srgb, currentColor 40%, transparent);
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;
    transition: text-decoration-color 150ms ease;
  }
  a:hover {
    text-decoration-color: currentColor;
  }
  a:focus-visible {
    outline: 2px solid var(--flora-link-color);
    outline-offset: 3px;
    border-radius: 2px;
  }
  blockquote {
    margin: 8px 0;
    padding: 4px 12px;
    border-left: 3px solid var(--sky-light);
    color: var(--ink-base);
  }

  hr {
    border: none;
    border-top: 1px solid var(--sky-light);
    margin: 14px 0;
  }

  [data-theme='dark'] & {
    p, li, td, blockquote { color: #e0e0e0; }
    th { color: #ececec; }
    h1, h2, h3, h4, h5, h6 { color: #f5f5f5; }
  }
`;

export { AssistantBubble, AssistantRow, AvatarImg, AvatarWrap, UserBubble, UserRow };
